import { Component } from '@angular/core';



@Component({
  selector: 'app-package-cards',
  templateUrl: './package-cards.component.html',
  styleUrls: ['./package-cards.component.css']
})
export class PackageCardsComponent {

  isNavOpen = false;

}